'use es6';

import { VISITOR } from 'conversations-message-history/constants/messageUses';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getMessage } from 'conversations-message-history/unpublished-messages/operators/getters';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import CommonMessageContent from '../common-message/CommonMessageContent';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import SVGWarning from 'visitor-ui-component-library-icons/icons/SVGWarning';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FailedToPublishMessage extends PureComponent {
  render() {
    const {
      fileAttachments,
      message: failedToPublishMessage,
      onRepublish
    } = this.props;
    const message = getMessage(failedToPublishMessage);
    return /*#__PURE__*/_jsxs(PrimaryMessage, {
      use: VISITOR,
      "data-test-id": "primary-message",
      children: [/*#__PURE__*/_jsx(CommonMessageContent, {
        fileAttachments: fileAttachments,
        isLastMessage: true,
        message: message
      }), /*#__PURE__*/_jsx(PrimaryMessageFooter, {
        children: /*#__PURE__*/_jsxs(VizExSmall, {
          use: "error",
          children: [/*#__PURE__*/_jsx(VizExIcon, {
            icon: /*#__PURE__*/_jsx(SVGWarning, {}),
            className: "m-right-1"
          }), /*#__PURE__*/_jsx(VizExLink, {
            onClick: () => onRepublish(message),
            use: "error",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "conversations-visitor-message-history.status.publishing.PUBLISH_FAILED"
            })
          })]
        })
      })]
    });
  }
}
FailedToPublishMessage.displayName = 'FailedToPublishMessage';
FailedToPublishMessage.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  message: RecordPropType('FailedToPublish').isRequired,
  onRepublish: PropTypes.func.isRequired
};
export default FailedToPublishMessage;